export default { maxNumberOfPropertiesPerPage: 30 };
